import Common from "../common/Common";

class News1 {
  constructor() {
    this.common = new Common();
    this.filter1 = document.querySelector(".js-filter1");
    this.filter1Items = document.querySelectorAll(".js-filter1Item");
    this.filter1Target = document.querySelector(".js-filter1Target");
    this.filter1TargetItems = document.querySelectorAll(".js-filter1TargetItem");

    if (this.filter1Target) {
      this.initialize();
    }
  }

  initialize() {
    this.filter1Items.forEach(( filter1Item , i ) => {
      filter1Item.addEventListener("change", (e) => {
        this.change();
      });
    });
  }

  change() {
    // カテゴリー
    let filter1CateroryData = [];
    const filter1CateroryInput = document.querySelectorAll(".js-filter1CateroryInput");
    filter1CateroryInput.forEach(( item , i ) => {
      if( item.checked ) {
        filter1CateroryData.push(item.value);
      }
    });

    // 年度
    let filter1YearData = [];
    const filter1YearSelect = document.querySelector(".js-filter1YearSelect");
    filter1YearData.push(filter1YearSelect.value);

    // 一旦全部表示
    this.filter1TargetItems.forEach(( filter1TargetItem , i ) => {
      filter1TargetItem.style.display = 'block';
    });

    if (filter1CateroryData.filter(Boolean).length == 0 && filter1YearData.filter(Boolean).length == 0) {
      // すべてチェックされていないので全部表示
      this.filter1TargetItems.forEach(( filter1TargetItem , i ) => {
        filter1TargetItem.style.display = 'block';
        filter1TargetItem.classList.remove('is-hidden');
      });
      this.filter1Target.classList.remove('is-empty');
    } else {
      // 一旦非表示
      this.filter1TargetItems.forEach(( filter1TargetItem , i ) => {
        filter1TargetItem.style.display = 'none';
        let isDisp = false;

        if (filter1CateroryData.filter(Boolean).length == 0) {
          isDisp = true;
        } else {
          const category = filter1TargetItem.dataset.category;
          if (filter1CateroryData.includes(category)) {
            isDisp = true;
          }
        }

        if (filter1YearData.filter(Boolean).length == 0) {
        } else if (isDisp) {
          isDisp = false;
          const year = filter1TargetItem.dataset.year;
          if (filter1YearData.includes(year)) {
            isDisp = true;
          }
        }

        // 表示/非表示
        if (isDisp) {
          filter1TargetItem.classList.remove('is-hidden');
          filter1TargetItem.style.display = 'block';
          // 件数加算
        } else {
          filter1TargetItem.classList.add('is-hidden');
          filter1TargetItem.style.display = 'none';
        }

      });

      const itemNum = this.filter1TargetItems.length;
      const itemHiddenNum = document.querySelectorAll(".js-filter1TargetItem.is-hidden").length;
      if( itemNum == itemHiddenNum ) {
        this.filter1Target.classList.add('is-empty');
      } else {
        this.filter1Target.classList.remove('is-empty');
      }
    }
  }
}

export default News1;